import { html, LitElement } from 'lit-element';

import groupBy from 'lodash-es/groupBy';

import { CTSubGroup } from './CTSubGroup.js';

/**
 * @element ct-group
 * @prop {Object} correctness - Group correctness (one of: correct/correct-partially/incorrect/unanswered)
 * @prop {Number} studentsAnsweredNr - The number of all the student that answered the question
 * @prop {Object} item - item
 * @prop {Object} group - Group of sessions
 */
export class CTGroup extends LitElement {
  static get properties() {
    return {
      correctness: { type: String, attribute: false },
      studentsAnsweredNr: { type: Number, attribute: false },
      item: { type: Object, attribute: false },
      group: { type: Object, attribute: false },
    };
  }

  constructor(props) {
    super(props);

    if (!customElements.get('ct-sub-group')) {
      customElements.define('ct-sub-group', CTSubGroup);
    }
  }

  createRenderRoot() {
    return this;
  }

  render() {
    if (!this.group || !this.correctness) {
      return html``;
    }

    const { headers, sessions } = this.group || {};
    const { config, classroomToolLayout } = this.item || {};
    const { models } = config || {};

    const subgroupHeaders = groupBy(headers, 'sessionValueSubGroup');
    const subgroupSessions = groupBy(sessions, 'sessionValueSubGroup');

    const subgroupsKeys = Object.keys(subgroupHeaders);

    const layoutClass = classroomToolLayout ? `ct-${classroomToolLayout}` : '';

    // for MCA items, we show a correctness label
    let renderCorrectnessLabel = '';

    if (
      models.length === 1 &&
      models[0].element === 'multiple-choice' &&
      models[0].choiceMode === 'radio'
    ) {
      const correctnessLabel =
        this.correctness[0].toUpperCase() + this.correctness.slice(1);
      const labelClass =
        correctnessLabel !== 'Unanswered'
          ? 'correctness-label'
          : 'correctness-label hidden';

      renderCorrectnessLabel = html` <div class="${labelClass}">
        ${correctnessLabel}
      </div>`;
    }

    return html` <div class="ct-group">
      ${renderCorrectnessLabel}
      <div
        class="ct-group_header-correctness-indicator ${this.correctness}"
      ></div>
      <div class="ct-subgroups ${layoutClass}">
        ${subgroupsKeys.map((groupKey, index) => {
          const subgroup = {
            headers: subgroupHeaders[groupKey],
            sessions: subgroupSessions[groupKey],
          };

          return html`<ct-sub-group
            .index=${index}
            .itemConfig=${config}
            .layout=${classroomToolLayout}
            .subgroup=${subgroup}
            .studentsAnsweredNr=${this.studentsAnsweredNr}
          ></ct-sub-group>`;
        })}
      </div>
    </div>`;
  }
}

export default CTGroup;
